export default "__VITE_ASSET__faabe0be__"